// extracted by mini-css-extract-plugin
module.exports = {"component":"Hero_component__VtIIT","title":"Hero_title__qEEDw","subtitle":"Hero_subtitle__gRzLF"};